var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    attrs: {
      "id": "AddressVerificationModal"
    }
  }, [_c('form', {
    staticClass: "flex flex-col",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.confirmError.apply(null, arguments);
      }
    }
  }, [_c('h2', [_vm._v("Sorry about that, try again")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    staticClass: "button--filled self-center mt-12 w-full",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Ok")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };